import { render, staticRenderFns } from "./LessonFormDialog.vue?vue&type=template&id=dbfdbd74&scoped=true"
import script from "./LessonFormDialog.vue?vue&type=script&lang=js"
export * from "./LessonFormDialog.vue?vue&type=script&lang=js"
import style0 from "./LessonFormDialog.vue?vue&type=style&index=0&id=dbfdbd74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfdbd74",
  null
  
)

export default component.exports